//
// Site Header
// --------------------------------------------------
// Functionality for mobile navigation toggling

const _debounce = require('lodash.debounce');
const _throttle = require('lodash.throttle');

window.addEventListener('load', () => {
    const siteHeader = document.getElementById('siteHeader');
    const offCanvasMenuMobile = document.getElementById('offCanvasMenuMobile');
    const menuToggleMobile = document.getElementById('menuToggleMobile');
    const navBackdropMobile = document.getElementById('navBackdropMobile');
    let scrollLimit = 500;
    let navOpenScrollPosY = window.scrollY;

    // id for below is retrieved from animated-hamburger.svg
    const hamburger = document.getElementById('ek0RzW3Va4r1');
    // https://www.svgator.com/help/getting-started/svgator-player-js-api
    // ^ related to below svgatorPlayer controls
    const player = hamburger ? hamburger.svgatorPlayer : {};

    // desktop functions
    const handleDesktopNavScrollThrottled = _throttle(handleDesktopNavScroll, 200);
    window.addEventListener('scroll', handleDesktopNavScrollThrottled);
    handleDesktopNavScroll();

    if (offCanvasMenuMobile && menuToggleMobile) {
        menuToggleMobile.addEventListener('click', () => {
            // updates navOpenScrollPos on nav open so scroll limit can compare with the current open position
            navOpenScrollPosY = window.scrollY;

            if (siteHeader.dataset.open === 'false') {
                siteHeader.dataset.open = 'true';
                navBackdropMobile.dataset.open = 'true';
            } else {
                siteHeader.dataset.open = 'false';
                navBackdropMobile.dataset.open = 'false';
            }

            if (hamburger) {
                if (player.play) {
                    if (player.hasEnded || player.isPlaying) {
                        player.reverse();
                    } else {
                        player.play();
                    }
                }
            }

            scrollLimit = (offCanvasMenuMobile.offsetHeight / 3) * 2;
            startListening();
        });
    }

    function closeMobileNav() {
        if (siteHeader.dataset.open === 'true') {
            siteHeader.dataset.open = 'false';
            navBackdropMobile.dataset.open = 'false';

            if (hamburger) {
                if (player.play) {
                    player.reverse();
                }
            }
        }
    }

    // closes open menus and resets nav to default state
    function closeAllNavs() {
        closeMobileNav();
    }

    function startListening() {
        window.addEventListener('click', clickListener);
        window.addEventListener('resize', resizeListener);
        window.addEventListener('scroll', scrollListener);
    }

    function stopListening() {
        window.removeEventListener('click', clickListener);
        window.removeEventListener('resize', resizeListener);
        window.removeEventListener('scroll', scrollListener);
    }

    // Throttle for resize listener to close open menus on page resize
    const closeNavResizeThrottle = _throttle(resizeCloseNav, 50, {leading: true, trailing: true});

    function resizeCloseNav() {
        let windowSize = window.innerWidth;
        setTimeout(() => {
            if (windowSize !== window.innerWidth) {
                closeAllNavs();
                stopListening();
            }
        }, 50);
    }


    // Debounce for click listener to close open menus if click is not inside menu
    const closeNavClickDebounce = _debounce(clickOutsideCloseNav, 50, {leading: true, trailing: true});

    function clickOutsideCloseNav() {
        if (document.getElementById('navBackdropMobile').contains(event.target) || document.querySelector('button[data-mobile-nav-button]').contains(event.target)) {
            closeAllNavs();
            stopListening();
        }
    }


    // Throttle for scroll listener to close open menus if scroll exceeded scroll limit
    const closeNavScrollThrottle = _throttle(scrolledPastLimit, 50, {leading: true, trailing: true});

    function scrolledPastLimit() {
        if (window.scrollY >= (scrollLimit + navOpenScrollPosY) || window.scrollY <= (navOpenScrollPosY - scrollLimit)) {
            closeAllNavs();
            stopListening();
        }
    }

    const clickListener = () => {
        closeNavClickDebounce(event);
    };

    const resizeListener = () => {
        closeNavResizeThrottle();
    };

    const scrollListener = () => {
        closeNavScrollThrottle();
    };

    function handleDesktopNavScroll() {
        const siteHeader = document.getElementById('siteHeader');
        
        if (window.pageYOffset > 5 || document.documentElement.scrollTop > 5) {
            siteHeader.setAttribute('data-active', 'true');
        } else {
            siteHeader.setAttribute('data-active', 'false');
        }
    }
});